// © Copyright 2026 Emman Consulting SAS
import React, { useState } from "react";
import { flagUrl, flagSrcSet } from "../../data/albumData.js";

const FlagImg = React.memo(function FlagImg({cc, className, style}) {
const [err, setErr] = useState(false);
if (!cc || err) return null;
const srcSet = flagSrcSet(cc);
const sizes = "(max-width: 480px) 20px, (max-width: 768px) 40px, 80px";
return (
<picture>
  <source srcSet={srcSet.replace(/\.png/g, '.webp')} type="image/webp" sizes={sizes} />
  <img
    src={flagUrl(cc)}
    srcSet={srcSet}
    sizes={sizes}
    alt={cc}
    className={className||"fimg"}
    style={style}
    loading="lazy"
    onError={()=>setErr(true)}
  />
</picture>
);
});

export default FlagImg;
